/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Price_Include1_TitleInputs */

const es_landing_price_include1_title = /** @type {(inputs: Landing_Price_Include1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambio de uso, despacho y enrole`)
};

const gl_landing_price_include1_title = /** @type {(inputs: Landing_Price_Include1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambio de uso, despacho e enrolamento`)
};

const en_landing_price_include1_title = /** @type {(inputs: Landing_Price_Include1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change of use, dispatch and enrolment`)
};

/**
* | output |
* | --- |
* | "Change of use, dispatch and enrolment" |
*
* @param {Landing_Price_Include1_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_price_include1_title = /** @type {((inputs?: Landing_Price_Include1_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Price_Include1_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_price_include1_title(inputs)
	if (locale === "en") return en_landing_price_include1_title(inputs)
	return es_landing_price_include1_title(inputs)
});